import { useGtm } from '~/composables';

// TODO(AB-2221): удалить, когда frontkit вернёт page tracking
export default defineNuxtPlugin(() => {
  const { push } = useGtm();

  useRouter().afterEach((to) => {
    setTimeout(() => {
      push({
        routeName: to.name,
        pageType: 'PageView',
        pageUrl: to.fullPath,
        pageTitle: document.title || '',
        event: 'nuxtRoute',
      });
    }, 250);
  });
});
